import { Component, OnInit, ChangeDetectorRef, ViewChild } from '@angular/core';
import { AbstractCustomControl } from '../abstract-custom-control';
import { Validator } from '@angular/forms';
import { MakeValidator, MakeProvider } from '../abstract-custom-control';
import { InputComponent } from '../input/input/input.component';
import { CommonService } from '../../base-services/common.service';

@Component({
  selector: 'yt-fw-zrc',
  templateUrl: './zrc.component.html',
  providers: [MakeProvider(ZrcComponent), MakeValidator(ZrcComponent)]
})
export class ZrcComponent extends AbstractCustomControl<string> implements OnInit, Validator {

  _Zrc1: string = '';
  _Zrc2: string = '';
  _Zrc3: string = '';

  constructor(protected changeDetectorRef: ChangeDetectorRef) { 
    super(changeDetectorRef);
  }

  ngOnInit() {
  }

  @ViewChild('zrc1', { static: true }) zrc1: InputComponent;
  @ViewChild('zrc2', { static: true }) zrc2: InputComponent;
  @ViewChild('zrc3', { static: true }) zrc3: InputComponent;

  onInputZrc(value){    
    this._Zrc1 = !this._Zrc1 ? '' : this._Zrc1;
    this._Zrc2 = !this._Zrc2 ? '' : this._Zrc2;
    this._Zrc3 = !this._Zrc3 ? '' : this._Zrc3;
    this.value = this._Zrc1 +'-'+ this._Zrc2 +'-'+ this._Zrc3; 
    this.onChange(this.value); 

  }

  writeValue(value: string){
    if (value!=null){
      super.writeValue(value);
      const zrc = this.value.split('-');
      this._Zrc1=zrc[0] != undefined ? zrc[0] : '';
      this._Zrc2=zrc[1] != undefined ? new CommonService().PadLeft(zrc[1],"0",13).trim() : '';
      this._Zrc3=zrc[2] != undefined ? new CommonService().PadLeft(zrc[2],"0",2).trim() : '';
      this.value = this._Zrc1 +'-'+ this._Zrc2 +'-'+ this._Zrc3; 
      this.onChange(this.value); 
    }
  }

  setDisabledState(isDisabled: boolean){
    super.setDisabledState(isDisabled);
    this.zrc1.disabled = isDisabled;
    this.zrc2.disabled = isDisabled;
    this.zrc3.disabled = isDisabled;
  }

  onChangeZrc2(value){
    if (value){
      value = new CommonService().PadLeft(value,"0",13).trim();
      this._Zrc2 = value;
      this.writeValue(this._Zrc1+"-"+this._Zrc2+"-"+this._Zrc3);
    }
  }

  onChangeZrc3(value){
    if (value){
      value = new CommonService().PadLeft(value,"0",2).trim();
      this._Zrc3 = value;
      this.writeValue(this._Zrc1+"-"+this._Zrc2+"-"+this._Zrc3);
    }
  }
}
